import { COLOR } from './color';
export const ELEVATION = {
    A: `0 0 4px ${COLOR.INK_24}`,
    B: `0 0 8px ${COLOR.INK_24}`,
    C: `0 0 12px ${COLOR.INK_24}`,
    NONE: 'none',
};
